// src/composant/Cart.jsx corrigido
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { adicionarItem, deleteFromCart } from './../redux/cartReducer';

export default function Cart() {
  const dispatch = useDispatch();
  const itens = useSelector(state => state.cartReducer.items);

  const adicionar = (item) => {
    dispatch(adicionarItem({ nome: item.nome, preco: parseFloat(item.preco) }));
  };

  const remover = (id) => {
    dispatch(deleteFromCart(id));
  };

  return (
    <div>
      <h2>Carrinho</h2>
      <ul>
        {itens.map((item, index) => (
          <li key={index}>
            {item.nome} - R$ {(item.preco * item.quantidade).toFixed(2)} x {item.quantidade}
            <button onClick={() => adicionar(item)}>+</button>
            <button onClick={() => remover(item.id_produto)}>-</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
